import { StringParam, useQueryParams } from 'use-query-params';
import {
  DEFAULT_LIST_PARAMS,
  GetUrlParams,
  ListParams,
  PaginationParams,
} from '@lib/enums/urls';

const paramConfig = {
  [GetUrlParams.Page]: StringParam,
  [GetUrlParams.PerPage]: StringParam,
  [GetUrlParams.OrderingField]: StringParam,
  [GetUrlParams.OrderingDirection]: StringParam,
} as const;

const usePaginationParams = (): [ListParams, typeof setPaginationParams] => {
  const [rawParams, setPaginationParams] =
    useQueryParams<typeof paramConfig>(paramConfig);

  const cleanedParams = Object.fromEntries(
    Object.entries(rawParams).filter(([_, value]) => value !== undefined),
  ) as Partial<PaginationParams>;

  const paginationParams: ListParams = {
    ...DEFAULT_LIST_PARAMS,
    ...cleanedParams,
  };

  return [paginationParams, setPaginationParams];
};

export default usePaginationParams;
